import layout from '@/layout'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/finSet',
  component: layout,
  meta: {
    funcID: 'C0001',
    PID: 'C00',
  },
  children: ((pre) => [
    {
      path: 'budget',
      name: `${pre}budget`,
      meta: {
        ...meta,
        head: { back: false },
        title: '部门预算设置',
        funcID: 'C000101',
        PID: 'C00',
      },
      component: () => import('@/views/financial/finSet/budget'),
    },
    {
      path: 'budget/:pageType/:code?',
      name: `${pre}budget-detail`,
      meta: {
        ...meta,
        head: { back: false },
        title: ({ $route }) => {
          const { reportBudgetNo = '' } = $route.query || {}
          if (reportBudgetNo) {
            return `部门预算设置 | ${reportBudgetNo}`
          }
          return '部门预算设置'
        },
        funcID: 'C000101',
        PID: 'C00',
      },
      component: () => import('@/views/financial/finSet/budget/detail'),
    },
    {
      path: 'custBudget',
      name: `${pre}custBudget`,
      meta: {
        ...meta,
        funcID: 'C000102',
        PID: 'C00',
      },
      component: () => import('@/views/financial/finSet/custBudget'),
    },
  ])('financial-finSet-'),
}
